import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_310: DocMigration = {
  maxSchemaVersion: "0.0.310",
  description: "Ensure that a default elevation is always set",
  apply(json: any): any {
    const defaultElevations: { [id: string]: true } = {};

    for (const id in json.elevations) {
      const elevation = json.elevations[id];

      if (elevation.isDefault) {
        defaultElevations[id] = true;
      }
    }

    // If there's no default elevation set, attempt to set one
    if (!Object.values(defaultElevations).some(Boolean)) {
      const defaultElevation = Object.values(json.elevations)[0] as Record<string, any>;

      if (defaultElevation) {
        json.elevations[defaultElevation.id].isDefault = true;
      }
    } else if (Object.keys(defaultElevations).length > 1) {
      // If there's more than one default elevation set, unset all but the first one
      Object.keys(defaultElevations).forEach((id, index) => {
        if (index === 0) {
          return;
        }

        json.elevations[id].isDefault = false;
      });
    }

    return json;
  },
};

export default migration_0_0_310;
